import { AuthProvider } from "@intility/authentication-react";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { RouterProvider } from "react-router";
import { auth } from "./auth";
import { ColorModeApplier } from "./components/layout/ColorMode";
import { queryClient } from "./queryClient";
import { router } from "./router";

export default function App() {
  return (
    <StrictMode>
      <ColorModeApplier>
        <AuthProvider auth={auth}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </AuthProvider>
      </ColorModeApplier>
    </StrictMode>
  );
}
